import { Container } from '@symbiotic/green-state';
import { EnvConfigService } from '../support/EnvConfigService';
import { LocalhostHandlerConfig } from '../portal-react-app/LocalhostHandler';
import { AccountServiceConfig } from '../support/AccountService';
import { TenantServiceConfig } from '../support/TenantService';
import { TokenServiceConfig } from '../support/TokenService';
import { PluginLoaderConfig } from './PluginLoader';
import { NavServiceConfig } from '../support/NavService';
import { createHashHistory } from 'history';
import { AppHistory } from './AppHistory';

export const getContainer = async (): Promise<Container> => {
  const container = new Container();

  const envConfigService: EnvConfigService = container.get(EnvConfigService);
  const config = envConfigService.getConfig();

  container.registerInstance(LocalhostHandlerConfig, config);
  container.registerInstance(AccountServiceConfig, config);
  container.registerInstance(TenantServiceConfig, config);
  container.registerInstance(TokenServiceConfig, config);
  container.registerInstance(PluginLoaderConfig, config);
  container.registerInstance(NavServiceConfig, new NavServiceConfig(config));
  container.registerInstance(AppHistory, createHashHistory());

  return container;
};



// WEBPACK FOOTER //
// ./src/framework/ioc.ts